import { render, staticRenderFns } from "./edit-video-modal.vue?vue&type=template&id=a1a47016"
import script from "./edit-video-modal.vue?vue&type=script&lang=js"
export * from "./edit-video-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports